import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProductServiceService } from 'src/app/services/product-service.service';

@Component({
  selector: 'app-delete-product',
  templateUrl: './delete-product.component.html',
  styleUrls: ['./delete-product.component.scss']
})
export class DeleteProductComponent {

    constructor(
      public dialogRef: MatDialogRef<DeleteProductComponent>,
      @Inject(MAT_DIALOG_DATA) public data:any,
      private productserivice: ProductServiceService,
      
    ){
  
    }

      stateId : any ;
  ngOnInit() {
    this.stateId = this.data.data;
  }

    deleteState(){
    this.productserivice.deleteProduct(this.stateId).subscribe({
      next:(res:any)=>{
          this.productserivice.openSnack("Product Deleted sucessfully","Close");
          this.dialogRef.close('success');
      },
      error:(err)=>{
        this.productserivice.openSnack(err.error.message,"close");
      }
    })
  }

  closeBtn(){
    this.dialogRef.close();
  }
}
